import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import FontFaceObserver from "fontfaceobserver";
import WithThemePersistence from "./components/WithThemePersistence";
import {
  NavLink,
  useLocation,
  Routes,
  Outlet,
  useParams,
  useNavigate,
  Navigate,
  Route,
  useHref,
} from "react-router-dom";
import {
  motion,
  useSpring,
  useTransform,
  AnimateSharedLayout,
  AnimatePresence,
  useScroll,
  transform,
} from "framer-motion";

//components

import Preloader from "./components/Preloader";
import Spinner from "./components/Spinner";


//utils
// import { keepTheme } from "./utils/theme";
import { useOnLoadImages } from "./hooks/useOnLoadImages";


//local styles
import styles from "./App.module.css";

function App() {
  const [className, setClassName] = useState("theme-dark");
  const navigate = useNavigate();

  const rootRef = useRef(null);
  const [fakeLoaded, setfakeLoaded] = useState(false);
  const [fontLoaded, setFontLoaded] = useState(false);
  const [preloaded, setPreloaded] = useState(false);
  const [windowLoaded, hasWindowLoaded] = useState(false);
  const [hero, showHero] = useState(1);
  const [gallery, hideGallery] = useState(1);
  const [vanished, setVanished] = useState(0);







  return (

    <>

      <div
        className={`${styles.spinner} w-100 h-100 flex pos-f t l `}
        style={
          !preloaded
            ? {
              opacity: 1,
              transform: "scale(0.8)",
            }
            : {
              opacity: 0,
              transform: "scale(3)",
              transitionDelay: "300ms",
            }
        }
      >
        <Spinner />
      </div>


      <div className={`${styles.themer} w-100 pos-a zi_10 padding flex flex-jc-fe`}><WithThemePersistence /></div>

      {/* preloader */}


      <div className={`${styles.preloader} pos-f flex flex-col  w-100 h-100`}>

        {/* {Math.round(animatedPercentage)} */}
        Theme 3 <div className={`font-caption padding`}>Coming Soon</div>






      </div >
      <div className={`${styles.theme3} font-body padding pos-a b w-100 h-30 flex flex-jc-ce flex-ai-ce`}>
        <a className={` link  `} href="https://t1.samarth.design" target="_blank" rel="noopener noreferrer">Theme 1</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a className={` link  `} href="https://t2.samarth.design" target="_blank" rel="noopener noreferrer">Theme 2</a>
      </div>

    </>

  );
}

export default App;
